import './App.css'
import React from 'react'
import { Amplify } from 'aws-amplify'
import config from './amplifyconfiguration.json'
import { Authenticator } from '@aws-amplify/ui-react'
import '@aws-amplify/ui-react/styles.css'
import Home from './Home'

const getAmpEnv = (): string | undefined => {
  const regex = /(dev|stage|prod)$/

  const extractEnv = (str: string): string | undefined => {
    const match = str.match(regex)
    return (match != null) ? match[1] : undefined
  }

  const matches: Array<string | undefined> = [
    ...config.aws_cloud_logic_custom.map((api) => extractEnv(api.endpoint)),
    ...config.aws_dynamodb_table_schemas.map((table) =>
      extractEnv(table.tableName)
    ),
    extractEnv(config.aws_user_files_s3_bucket)
  ].filter((match): match is string => match !== undefined)

  const uniqueMatches = new Set(matches)

  if (
    matches.length ===
      config.aws_cloud_logic_custom.length +
        config.aws_dynamodb_table_schemas.length +
        1 &&
    uniqueMatches.size === 1
  ) {
    return matches[0]
  } else {
    return undefined
  }
}

// Usage
const ampEnv = getAmpEnv()

if (ampEnv !== undefined) {
  console.log(`Matching environment: ${ampEnv}`)
} else {
  console.log('No consistent environment match found')
}

if (ampEnv !== undefined) {
  switch (ampEnv) {
    case 'dev':
      config.aws_user_pools_web_client_id = '6sp9m65ncgbikj756ovu1sebj6'
      break
    case 'stage':
      config.aws_user_pools_web_client_id = '2gau9b9lvddet414h075fp03t6'
      break
    case 'prod':
      config.aws_user_pools_web_client_id = 'PROD_APP_CLIENT'
      break
    default:
      console.log('No environment specified!')
      break
  }
}

Amplify.configure(config)

const App: React.FC = () => {
  return (
    <div className='page'>
      <Authenticator.Provider>
        <Home />
      </Authenticator.Provider>
    </div>
  )
}

export default App
